import { createElement, useEffect, useState } from 'react';
import cls from 'classnames/bind';
import style from './index.module.scss';
import { Button, Input, Row, Col, Tree, Checkbox, Divider, Space, Tag, Pagination, Progress, message, } from 'antd';
import { treeDept, queryUserByParentId, queryUserByIds } from '../../../api/form';
import HcDialog from '../../common/HcDialog';
const cx = cls.bind(style);
const { Search } = Input;
const CheckboxGroup = Checkbox.Group;
const fieldNames = {
    title: 'label',
    key: 'value',
};
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const edit = urlParams.get('edit');
const personnelDialog = (props) => {
    const { value, mode, onChange } = props;
    const [visible, setVisible] = useState(false);
    const openDialog = () => {
        setVisible(true);
    };
    const closeDialog = () => {
        setTempValue(value || []);
        setVisible(false);
    };
    useEffect(() => {
        setTempValue(value || []);
    }, [value]);
    const [treeData, setTreeData] = useState([]);
    const [tempValue, setTempValue] = useState(value || []);
    useEffect(() => {
        if (edit !== '3') {
            treeDept('0').then((res) => {
                if (res.data) {
                    setTreeData(res.data);
                }
            });
        }
    }, []);
    const [personList, setPersonList] = useState([]);
    const [curnode, setCurnode] = useState('0');
    const nodeSelect = ([id]) => {
        setCurnode(id || '0');
        setCurrent(1);
        queryList();
    };
    const [indeterminate, setIndeterminate] = useState(false);
    const [checkAll, setCheckAll] = useState(false);
    const [checkedList, setCheckedList] = useState([]);
    const [plainOptions, setPlainOptions] = useState([]);
    const onCheckAllChange = (e) => {
        setIndeterminate(false);
        const checked = e.target.checked;
        if (checked) {
            setTempValue(Array.from(new Set([...tempValue, ...plainOptions])));
            setCheckedList(plainOptions);
        }
        else {
            const temp = tempValue.filter((item) => {
                return !plainOptions.includes(item);
            });
            setCheckedList([]);
            setTempValue(temp);
        }
        setCheckAll(checked);
    };
    const pikePerson = (list) => {
        setCheckedList(list);
        const excludesTemp = plainOptions.filter((item) => !list.includes(item));
        const clone = Array.from(new Set([...tempValue, ...list]));
        const temp = clone.filter((item) => !excludesTemp.includes(item));
        setTempValue(temp);
    };
    function judgingStatus(list) {
        if (list.length === 0) {
            setCheckAll(false);
            setIndeterminate(false);
        }
        else if (list.length === plainOptions.length) {
            setCheckAll(true);
            setIndeterminate(false);
        }
        else {
            setIndeterminate(true);
            setCheckAll(false);
        }
    }
    useEffect(() => {
        judgingStatus(checkedList);
    }, [checkedList]);
    const handleOk = () => {
        closeDialog();
        if (edit !== '3') {
            onChange(tempValue);
        }
    };
    const updateTreeData = (list, key, children) => list.map((node) => {
        if (node.key === key) {
            return {
                ...node,
                children,
            };
        }
        if (node.children) {
            return {
                ...node,
                children: updateTreeData(node.children, key, children),
            };
        }
        return node;
    });
    const onLoadData = ({ key, children }) => new Promise((resolve) => {
        if (children) {
            resolve();
            return;
        }
        treeDept(key).then((res) => {
            if (res?.data) {
                setTreeData((origin) => updateTreeData(origin, key, res.data || []));
                resolve();
            }
            else {
                message.error('子树获取失败！');
            }
        });
    });
    const forMap = ({ userId, nickName }) => {
        const tagElem = (createElement(Tag, { closable: edit !== '3', color: "#2db7f5", onClose: (e) => {
                e.preventDefault();
                setTempValue(tempValue.filter((item) => item !== userId));
                setCheckedList(checkedList.filter((item) => item !== userId));
            } }, nickName));
        return (createElement("span", { key: userId, style: { display: 'inline-block' } }, tagElem));
    };
    const [text, setText] = useState('');
    const searchPerson = (text) => {
        setCurrent(1);
        setText(text);
    };
    const queryList = () => {
        if (edit === '3')
            return;
        if (visible && (curnode || text)) {
            queryUserByParentId({
                pageNum: current,
                deptId: curnode,
                nickName: text,
            }).then((res) => {
                setTotal(res.total);
                setPersonList(res.rows.map((item) => ({ label: item.nickName, value: item.userId })));
                const plains = res.rows.map((item) => item.userId);
                setPlainOptions(plains);
                const list = tempValue.filter((item) => plains.includes(item));
                setCheckedList(list);
            });
        }
    };
    const [current, setCurrent] = useState(1);
    const [total, setTotal] = useState(0);
    useEffect(() => {
        queryList();
    }, [current, curnode, text, visible]);
    const [infolist, setInfoList] = useState([]);
    useEffect(() => {
        if (tempValue.length) {
            queryUserByIds(tempValue).then((res) => {
                setInfoList(res.data);
            });
        }
        else {
            setInfoList([]);
        }
    }, [tempValue]);
    return (createElement("div", { className: cx('fake_select') },
        createElement(Button, { disabled: mode === 'design', onClick: openDialog, type: "primary" }, "\u4EBA\u5458\u9009\u62E9"),
        createElement(HcDialog, { title: "\u4EBA\u5458\u9009\u62E9", visible: visible, onOk: handleOk, onCancel: closeDialog, onClose: closeDialog, width: "75vw" },
            createElement("div", { className: cx('persenel_panel') },
                createElement(Row, null,
                    createElement(Col, { span: 16 },
                        createElement(Row, null,
                            createElement("div", { className: cx('search') },
                                createElement(Search, { disabled: edit === '3', allowClear: true, placeholder: "\u8BF7\u8F93\u5165\u7528\u6237\u59D3\u540D", onSearch: searchPerson }))),
                        createElement(Row, null,
                            createElement(Col, { span: 12 },
                                createElement("div", { className: cx(['module_box', 'top']) },
                                    createElement(Tree, { showLine: false, loadData: onLoadData, treeData: treeData, onSelect: nodeSelect }))),
                            createElement(Col, { span: 12 },
                                createElement("div", { className: cx(['module_box', 'left', 'top']) },
                                    createElement("div", { className: cx('select_panel') },
                                        createElement(Checkbox, { disabled: edit === '3', indeterminate: indeterminate, onChange: onCheckAllChange, checked: checkAll }, "\u5168\u9009"),
                                        createElement(Divider, null),
                                        createElement(CheckboxGroup, { value: checkedList, onChange: pikePerson, options: personList })),
                                    createElement(Pagination, { onChange: setCurrent, simple: true, current: current, size: "small", pageSize: 20, total: total }))))),
                    createElement(Col, { span: 8 },
                        createElement("div", { className: cx(['module_box', 'full', 'left']) },
                            createElement("div", { className: cx('limit') },
                                createElement(Progress, { className: cx('propgress'), percent: tempValue.length / 3, format: (per) => per.toFixed(2) + '%', size: "small" }),
                                createElement("div", null, "\u6700\u591A\u9009\u62E9300\u4EBA")),
                            createElement("div", { className: cx(['p_list']) },
                                createElement(Space, { size: [8, 16], wrap: true }, infolist.map(forMap))))))))));
};
export default personnelDialog;
